<template>
  <div v-if="filters && filters.length" class="multi_term_input_container">
    <div v-for="filter in filters" :key="filter.designator" class="multi_term_filter">
      <div class="input_section">
        <input
          v-model="currentInput[filter.designator]"
          @keyup.enter="addTerm(filter.designator)"
          class="outlined input_horizontal_space input_placeholder"
          :class="filter.class"
          :placeholder="filter.placeholder || 'Enter search term and press Enter'"
        >
        <button @click="addTerm(filter.designator)" class="button is-small is-info add_term_btn">
          Add
        </button>
      </div>

      <div v-if="terms[filter.designator] && terms[filter.designator].length" class="terms_container">
        <span
          v-for="(term, index) in terms[filter.designator]"
          :key="index"
          class="tag is-medium is-info term_tag"
        >
          {{ term }}
          <button
            class="delete is-small"
            @click="removeTerm(filter.designator, index)"
          ></button>
        </span>
      </div>
    </div>

    <button
      @click="submit(false)"
      class="button is-success search_btn"
      :disabled="!hasTerms"
    >
      סיימתי! (Done)
    </button>
    <button
      v-if="hasTerms"
      @click="clearAll()"
      class="button is-light clear_btn"
    >
      Clear All
    </button>
  </div>
</template>

<script>
export default {
  name: 'filter-multi-term-input',
  props: ['filters'],
  data () {
    return {
      terms: {},
      currentInput: {}
    }
  },
  computed: {
    hasTerms () {
      return Object.values(this.terms).some(termArray => termArray && termArray.length > 0)
    }
  },
  created () {
    this.filters.forEach(filter => {
      this.$set(this.terms, filter.designator, [])
      this.$set(this.currentInput, filter.designator, '')

      // Load existing terms from URL if present
      if (this.$route.query[filter.designator]) {
        const existingTerms = this.$route.query[filter.designator].split(' + ')
        this.$set(this.terms, filter.designator, existingTerms)
      }
    })
  },
  methods: {
    addTerm (designator) {
      const input = this.currentInput[designator].trim()
      if (input && !this.terms[designator].includes(input)) {
        this.terms[designator].push(input)
        this.currentInput[designator] = ''
      }
    },
    removeTerm (designator, index) {
      this.terms[designator].splice(index, 1)
    },
    clearAll () {
      this.filters.forEach(filter => {
        this.terms[filter.designator] = []
        this.currentInput[filter.designator] = ''
      })
    },
    submit (ignore) {
      let query = ignore ? {} : { ...this.$route.query }

      this.filters.forEach(filter => {
        if (this.terms[filter.designator] && this.terms[filter.designator].length > 0) {
          // Join terms with ' + ' separator for backend
          query[filter.designator] = this.terms[filter.designator].join(' + ')
        } else {
          // Remove the parameter if no terms
          delete query[filter.designator]
        }
      })

      this.$router.push({ path: this.$route.path, query: query })
    }
  }
}
</script>

<style scoped>
.multi_term_input_container {
  margin: 15px 0 15px 30px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.multi_term_filter {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.input_section {
  display: flex;
  align-items: center;
  gap: 10px;
}

.input_horizontal_space {
  margin-right: 10px;
  min-width: 300px;
}

.input_placeholder::placeholder {
  color: #666;
  opacity: 1;
}

.terms_container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
  min-height: 50px;
  align-items: center;
}

.term_tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: #3273dc;
  color: white;
  border-radius: 4px;
  font-size: 14px;
}

.term_tag .delete {
  background-color: rgba(255, 255, 255, 0.3);
}

.term_tag .delete:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

.add_term_btn {
  white-space: nowrap;
}

.search_btn {
  align-self: flex-start;
  font-weight: bold;
  min-width: 150px;
}

.clear_btn {
  align-self: flex-start;
  margin-left: 10px;
}

.search_btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
